module.exports = __webpack_public_path__ + "media/thumbnail.03b8931f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/fashionIcon/assets/thumbnail.jpg
// module id = ./src/templates/fashionIcon/assets/thumbnail.jpg
// module chunks = 0